<template>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 10C0 4.47715 4.47715 0 10 0V0C15.5228 0 20 4.47715 20 10V10C20 15.5228 15.5228 20 10 20V20C4.47715 20 0 15.5228 0 10V10Z"
            fill="var(--app-disabled-bg)"
        />
        <path
            d="M6.84082 10.75C6.42675 10.7498 6.09082 10.4141 6.09082 10C6.09082 9.58589 6.42675 9.25016 6.84082 9.25H13.1562C13.5705 9.25 13.9062 9.58579 13.9062 10C13.9062 10.4142 13.5705 10.75 13.1562 10.75H6.84082Z"
            fill="var(--app-text-grey-color)"
        />
        <path
            d="M9.24609 7C9.24609 6.58579 9.58188 6.25 9.99609 6.25C10.4103 6.25 10.7461 6.58579 10.7461 7L10.7461 13C10.7461 13.4142 10.4103 13.75 9.99609 13.75C9.58188 13.75 9.24609 13.4142 9.24609 13L9.24609 7Z"
            fill="var(--app-text-grey-color)"
        />
    </svg>
</template>
